import { menuCollapse, pageScroll, popupInit, phoneMask, clearInvalidInputs } from '../utils/index';
import Cart from '../modules/cart';
import AuthForm from '../modules/auth-form';
import './logout';

/* header menu burger */
const body = document.querySelector('body');
const header = document.querySelector('[data-ui-el="header"]');
const menuHeader = document.querySelector('[data-ui-el="menu-header"]');
const authPopup = document.querySelector('#auth.popup');
const platform = navigator.userAgent;
const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(platform);
const isWin = /Windows NT/i.test(platform);
const cart = new Cart();
const authForm = new AuthForm();
const createAccountButton = document.querySelector('[data-btn="create-account"]');
const hasAccountButton = document.querySelector('[data-btn="has-account"]');
const cookieSection = document.querySelector('[data-ui-el="cookie"]');
const cookieContinue = document.querySelector('[data-btn="cookie-continue"]');

if (authPopup) {
    authPopup.addEventListener('collapse', () => {
        authForm.hideVerificationForm();
        authForm.clearInputs(authForm.formInputs);

        if (createAccountButton && hasAccountButton) {
            createAccountButton.classList.add('active');
            hasAccountButton.classList.remove('active');
        }
    });

    authPopup.addEventListener('popup-open', (e) => {
        if (createAccountButton && hasAccountButton) {
            createAccountButton.classList.remove('active');
            hasAccountButton.classList.add('active');
        }
    });
}

if (cart.domElement) {
    cart.domElement.addEventListener('collapse', () => {
        cart.clearCartError500();
    });
}

if (isMacLike) {
    body.classList.add('apple');
}

if (isWin) {
    body.classList.add('win');
}

const tooltipLink = document.querySelectorAll('[data-tooltip-for]');

[...tooltipLink].forEach(item => {
    const tooltipId = item.dataset.tooltipFor;
    const tooltipTarget = document.querySelector(`[data-tooltip-id=${tooltipId}]`);

    if (!tooltipTarget) {
        return;
    }

    item.addEventListener('click', () => tooltipTarget.dispatchEvent(new Event('click')));
});

/* header menu */
if (menuHeader) {
    const menuBody = document.querySelector('[data-ui-el="menu-body"]');

    menuCollapse(menuHeader);

    menuHeader.addEventListener('click', (evt) => {
        const element = evt.target.closest('[data-ui-el="menu-burger"]');
        const tooltipVisible = menuHeader.querySelector('.visible[data-ui-el="tooltip"]');

        if (evt.target.closest('a[href]:not([href="#cart"])')) {
            menuCollapse(menuHeader);
            document.body.removeAttribute('data-menu-opened');
        }

        if (!element) {
            return;
        }

        if (tooltipVisible) {
            tooltipVisible.classList.remove('visible');
        }

        element.classList.toggle('active');
        menuHeader.classList.toggle('active');
        menuBody.classList.toggle('active');

        if (menuBody.classList.contains('active')) {
            pageScroll.lock();
            document.body.dataset.menuOpened = '';
            return;
        }

        pageScroll.unlock();
        document.body.removeAttribute('data-menu-opened');
    });
}

/* header switcher */
const siteSwitch = document.querySelector('[data-ref="site-switch"]');
const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

if (siteSwitch) {
    const switchList = siteSwitch.querySelector('[data-ref="site-switch-list"]');
    let isActiveSelect = false;

    window.addEventListener('click', (event) => {
        if (event.target.closest('[data-ref="site-switch"]') || !isActiveSelect) return;

        siteSwitch.classList.remove('active');
        switchList.style.maxHeight = null;
        isActiveSelect = false;
    });

    if (!isTouchDevice) {
        siteSwitch.addEventListener('mouseover', () => {
            if (isActiveSelect) return;

            siteSwitch.classList.add('active');
            switchList.style.maxHeight =`${switchList.scrollHeight}px`;
            isActiveSelect = true;
        });

        siteSwitch.addEventListener('mouseout', () => {
            if (!isActiveSelect) return;

            siteSwitch.classList.remove('active');
            switchList.style.maxHeight = null;
            isActiveSelect = false;
        });
    } else {
        siteSwitch.addEventListener('click', (event) => {
            const {target} = event;

            if (target.closest('[data-ref="site-switch-btn"]')) {
                isActiveSelect = siteSwitch.classList.toggle('active');
                switchList.style.maxHeight = (isActiveSelect) ? `${switchList.scrollHeight}px` : null;
            }
        });
    }
}

/* switch header fixed */
if (header) {
    window.addEventListener('scroll', () => {
        const positionY = body.getBoundingClientRect().top + 2;
        header.classList.toggle('header_scroll', positionY < 0);
    });

    header.classList.toggle('header_scroll', body.getBoundingClientRect().top < -2);
}

/* tooltip */
const tooltipButtons = document.querySelectorAll('[data-tooltip="tooltip"]');

[...tooltipButtons].forEach(tooltipBtn => {
    tooltipBtn.addEventListener('click', (event) => {
        const tooltipVisible = document.querySelector('[data-tooltip="tooltip"].visible');

        if (tooltipVisible) {
            tooltipBtn.classList.add('visible');
            tooltipVisible.classList.remove('visible');
            return;
        }

        tooltipBtn.classList.toggle('visible');
    });
});

window.addEventListener('click', (event) => {
    const { target } = event;
    const tooltipVisible = document.querySelector('[data-tooltip="tooltip"].visible');

    if (target.closest('[data-tooltip-for]') || target.closest('[data-tooltip="tooltip"]') || !tooltipVisible) {
        return;
    }

    tooltipVisible.classList.remove('visible');
});

/* popup init */
const popupLinkList = document.querySelectorAll('[data-ui-el="popup-link"]');
Array.from(popupLinkList).forEach((popupLink) => popupInit(popupLink));

/* form phone */
const phoneInputs = document.querySelectorAll('[data-type="tel"]') || null;

[...phoneInputs].forEach((phoneInput) => {
    phoneInput.addEventListener('input', function (e) {
        phoneMask(e.target);

        if (phoneInput.value.length > 18) {
            clearInvalidInputs(phoneInput);
        }
    });

    phoneInput.addEventListener('focus', function (e) {
        phoneMask(e.target);
    });

    phoneInput.addEventListener('blur', function (e) {
        if (!e.target.value.replace(/(\+38?0?)?\D?/g, '')) {
            e.target.value = '';
        }
    });
});

if(cookieContinue) {
    cookieContinue.addEventListener('click', (event) => {
        event.preventDefault();
        const date = new Date();
        date.setFullYear(date.getFullYear() + 1);
        document.cookie = `isCookieContinue=yes; path=/; expires=${date.toUTCString()}`;
        document.querySelector('[data-ui-el="cookie"]').remove();
    });
}
